import { create } from 'zustand';
import { DashboardFilterForm, DashboardSearchForm } from 'types';
import { getTodayStoredData, removeLocalStorageItem } from 'helpers';
import {
  LocalStorageKeys,
  getDefaultDashboardFilter,
  getDefaultDashboardSearch,
} from 'commons';

interface Store {
  dashboardSearch: DashboardSearchForm;
  dashboardFilter: DashboardFilterForm;
  filteredStore: string;
  filteredBrand: string;
}

interface Actions {
  reset: ({ brand, store }: { brand?: string; store?: string }) => void;
  setDashboardSearch: (dashboardSearch: DashboardSearchForm) => void;
  setDashboardFilter: (dashboardFilter: DashboardFilterForm) => void;
  setFilteredStore: (filteredStore: string) => void;
  setFilteredBrand: (filteredBrand: string) => void;
}

const defaultDashboardSearch = getDefaultDashboardSearch();
const defaultDashboardFilter = getDefaultDashboardFilter();

const initialState: Store = {
  dashboardSearch: getTodayStoredData<DashboardSearchForm>(
    LocalStorageKeys.DashboardSearch,
    defaultDashboardSearch
  ),
  dashboardFilter: getTodayStoredData<DashboardFilterForm>(
    LocalStorageKeys.DashboardFilter,
    defaultDashboardFilter
  ),
  filteredStore: '',
  filteredBrand: '',
};

const useStore = create<Store & Actions>((set, get) => ({
  ...initialState,
  reset: ({ brand, store }) => {
    removeLocalStorageItem(LocalStorageKeys.DashboardSearch);
    removeLocalStorageItem(LocalStorageKeys.DashboardFilter);
    set({
      ...initialState,
      filteredStore: store || '',
      filteredBrand: brand || '',
    });
  },

  setDashboardSearch: (dashboardSearch: DashboardSearchForm) =>
    set(() => ({ dashboardSearch })),
  setDashboardFilter: (dashboardFilter: DashboardFilterForm) =>
    set(() => {
      const { salesModes, statuses, deliveryModes } = dashboardFilter;
      return {
        dashboardFilter: {
          ...dashboardFilter,
          salesModes: salesModes.sort(),
          statuses: statuses.sort(),
          deliveryModes: deliveryModes.sort(),
        },
      };
    }),
  setFilteredStore: (filteredStore: string) => set(() => ({ filteredStore })),
  setFilteredBrand: (filteredBrand: string) => set(() => ({ filteredBrand })),
}));

export const DashboardFilterStore = {
  useStore,
};
